// extracted by mini-css-extract-plugin
export var downArrow = "_9u-0";
export var infoTooltipIcon = "_9u-3";
export var label = "_9u-1";
export var optionCard = "_9u-4";
export var upArrow = "_9u-2";